// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInCreateNewAccount";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "primary",
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        flex-direction: row;
        gap: 10px;
        ${xScreen("lt", "xs")} {
            flex-direction: column;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h4",
    as: "h2",
    css: css`
        margin-bottom: 0;
    `,
};
